import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import { useIsSharedWithMeEnabled } from "../../hooks/useProjectSharing";
import { useTracker } from "../../hooks/useTracker";

export default function NotFoundPage({ isProjectPage }: { isProjectPage?: boolean }) {
  const isSharedWithMeEnabled = useIsSharedWithMeEnabled();
  const tracker = useTracker();
  const navigation = useNavigation();

  const title = `${isProjectPage ? "Project" : "Design"} not found`;
  const message = `Contact the ${isProjectPage ? "project" : "design"} owner for help. The link may no longer be shared.`;
  return (
    <InfoPage
      title={title}
      description={message}
      primaryCTA={
        <Button
          variant="grayscale"
          onClick={() => {
            tracker.trackGoToDashboard({
              location: "request_access_page",
              destination: isSharedWithMeEnabled ? "shared_with_me" : "review_links",
            });
            navigation.goToProfile();
          }}
        >
          Go to Dashboard
        </Button>
      }
    />
  );
}
